import firebase from "firebase/app";
import "firebase/auth";

import { deleteToken, setToken } from "features/auth/functions/token";
import { AppThunk } from "services/redux/rootReducer";
import { AuthAction } from "features/auth/types/actions";

const listenToAuthState = (): AppThunk<firebase.Unsubscribe> => (dispatch) => {
    const unsubscribe = firebase.auth().onIdTokenChanged((user) => {
        if (user) {
            user.getIdTokenResult().then(({ token, claims }) => {
                // Token for firebase admin purposes
                setToken(token);
                dispatch({
                    type: AuthAction.LOGIN_USER,
                    role: claims.role,
                    uid: user.uid,
                });
            });
        } else {
            deleteToken();
            dispatch({
                type: AuthAction.LOGOUT_USER,
            });
        }
    });
    return unsubscribe;
};

export default listenToAuthState;
